const LoadingMod = ()=>{
    return(
        <div className="w-100 p-3" style={{padding:"30px"}}>
                <p className="text-center p-5" style={{textAlign:"center"}}>Loading, please wait.</p>
        </div>
    )
}
export default  LoadingMod